export default class Idle
{
  constructor()
  {
    this.name = 'idle';
  }

  on_enter(view)
  {
  }

  update(view)
  {
  }

  is_animating()
  {
    return false;
  }

  on_exit(view)
  {
  }
}
